/* eslint-disable no-plusplus,react/jsx-pascal-case */
import PropTypes from 'prop-types';
import React from 'react';
import { pageContext } from 'ctm-util-functions';
import { SimpleFlexbox } from '../../../../flexbox/flexbox';

/**
 * Main layout component for rendering a Filtered Out Features results row
 * @param {Object} props - The components props
 * @param {Array} props.xs - componentLists for xs breakpoint and above
 * @param {Array} props.md - componentLists for sm breakpoint and above
 * @param {Object} props.stateProps - The stateful product object passed in
 * @returns {Node} The row layout component
 * @constructor
 */
const LayoutFeatureFilteredOutResultsRow = ({ xs, md, stateProps }) => {
    const breakpoint = pageContext.getProps().pageState.breakpoint;

    switch (breakpoint) {
        case 'xs':
        case 'sm':
            return <_Xs componentLists={xs} stateProps={stateProps} />;
        default: {
            // MD to XXL breakpoint
            return <_Md componentLists={md} stateProps={stateProps} />;
        }
    }
};

LayoutFeatureFilteredOutResultsRow.propTypes = {
    xs: PropTypes.arrayOf(PropTypes.array),
    md: PropTypes.arrayOf(PropTypes.array),
    stateProps: PropTypes.object
};

/**
 * Private component to render layout for XS breakpoint
 * @param {Object} props - The components props
 * @param {Array} props.componentLists - all sub component lists to be rendered under this layout
 * @param {Object} props.stateProps - The stateful product object passed in
 * @returns {_Xs} Xs layout component
 * @private
 */
const _Xs = ({ componentLists, stateProps }) => {
    let i = 0;
    const { constructComponents } = pageContext.getProps().director;
    return (
        <SimpleFlexbox display="flex" wrap itemsCenter="xs" margin="top" padding="top_bottom" border="all" bgColor="brand_base_0">
            <SimpleFlexbox xs={4} sm={2} padding="left_right">
                {constructComponents(componentLists[i++], { stateProps })}
            </SimpleFlexbox>
            <SimpleFlexbox column flex={1} display="flex" padding="left_right">
                {constructComponents(componentLists[i], { stateProps })}
            </SimpleFlexbox>
        </SimpleFlexbox>
    );
};

_Xs.propTypes = {
    componentLists: PropTypes.arrayOf(PropTypes.array),
    stateProps: PropTypes.object
};

/**
 * Private component to render layout for MD breakpoint and up
 * @param {Object} props - The components props
 * @param {Array} props.componentLists - all sub component lists to be rendered under this layout
 * @param {Object} props.stateProps - The stateful product object passed in
 * @returns {_Md} Md layout component
 * @private
 */
const _Md = ({ componentLists, stateProps }) => {
    let i = 0;
    const { director: { constructComponents }, pageState: { breakpoint } } = pageContext.getProps();
    return (
        <SimpleFlexbox md={9} xl={breakpoint === 'xxl' ? 12 : 10} display="flex" wrap itemsCenter="xs" margin="top" border="all" bgColor="brand_base_0">
            <SimpleFlexbox md={2} padding="left_right">
                {constructComponents(componentLists[i++], { stateProps })}
            </SimpleFlexbox>
            <SimpleFlexbox md={6} lg={5} padding="left_right">
                {constructComponents(componentLists[i++], { stateProps })}
            </SimpleFlexbox>
            <SimpleFlexbox md={4} lg={5} padding="left_right" variant="flex_item_align_right">
                {constructComponents(componentLists[i], { stateProps })}
            </SimpleFlexbox>
        </SimpleFlexbox>
    );
};

_Md.propTypes = {
    componentLists: PropTypes.arrayOf(PropTypes.array),
    stateProps: PropTypes.object
};

export { LayoutFeatureFilteredOutResultsRow };
// exported for uni test
export { _Xs, _Md };
